import { classNames } from "Utils/utils";
import { FiAlertTriangle, FiClock } from "react-icons/fi";
import { REPORTABLE_INCIDENTS_TABLE } from "../../constants/incidentTypes";
import useCareLabels from "hooks/useCareLabels";

export const InstructionsStep = () => {
  const { participantLabel } = useCareLabels();
  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Critical Alert */}
      <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-4">
        <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
          <FiAlertTriangle className="w-5 h-5 text-red-600" />
        </div>
        <div>
          <h3 className="font-semibold text-red-800">
            Critical Incident Alert
          </h3>
          <p className="text-sm text-red-700 mt-1">
            If this incident resulted in{" "}
            <strong>death, serious injury, abuse, or harm</strong> to a
            {participantLabel.toLowerCase()}, it{" "}
            <strong>
              must be reported to the NDIS Commission within 24 hours
            </strong>.
          </p>
        </div>
      </div>

      {/* Reportable Incidents Table */}
      <div className="border border-gray-200 rounded-xl overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="font-semibold text-gray-900">
            Reportable incident MUST notify NDIS Commission within:
          </h3>
          <p className="text-xs text-gray-600 mt-1">
            (Timeframes are calculated from when a registered NDIS provider became aware of the incident)
          </p>
        </div>
        <div className="divide-y divide-gray-100">
          {REPORTABLE_INCIDENTS_TABLE.map((item, index) => (
            <div
              key={index}
              className={classNames(
                "flex items-center justify-between px-6 py-4",
                item.critical && "bg-red-50/50"
              )}
            >
              <div className="flex items-center gap-3 flex-1">
                {item.critical && (
                  <FiAlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0" />
                )}
                <span
                  className={classNames(
                    "text-sm",
                    item.critical ? "text-red-800 font-medium" : "text-gray-700"
                  )}
                >
                  {item.incident}
                </span>
              </div>
              <span
                className={classNames(
                  "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ml-4",
                  item.critical
                    ? "bg-red-100 text-red-700"
                    : "bg-blue-100 text-blue-700"
                )}
              >
                <FiClock className="w-3.5 h-3.5" />
                {item.timeframe}
              </span>
            </div>
          ))}
        </div>
        
        {/* Important Note */}
        <div className="bg-amber-50 border-t border-amber-200 px-6 py-4">
          <p className="text-sm text-amber-900">
            <strong>Important:</strong> If the incident has resulted in harm to a person with disability, it must be reported within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
};
